import * as routes from "utils/contants/urls";

import {
  ActionItem,
  Actions,
  Label,
  LabelAction,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow,
} from "components/shared/CustomComponentsStyle";
import * as urls from "utils/contants/urls";
import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row, Card, ListGroup } from "react-bootstrap";
import { view } from "assets/icons/icons";
import { StatusDocuments } from "utils/contants/enums";
import { Body } from "./DetailContractCandidateStyle";
import BreadCrumb from "components/Layout/breadcrumb";

import {
  SelectFieldInput,
  CheckBox,
  TextAreaField,
  ButtonDefault,
  ButtonSecondary,
} from "components/shared/CustomInputs";

import ButtonUpload from "components/ButtonUpload";

import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import Load from "components/Layout/Load";
import Pagination from "components/Pagination";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Creators as contractsAction } from "store/ducks/contracts";

import {
  YesOrNoWithTextDialog,
  YesOrNoDialog,
  Title,
} from "components/shared/CustomComponents";

const DetailContractCandidate = ({
  match,
  candidateFiles,
  filesCandidateSelected,
  isLoading,
  location,
  setStatusFileRequest,
  confirmAnalisys,
  incluseNewDoc,
  requestReUploadContract,
  changeContractRequest,
  redirectToContracts,
  tipoContratoList,
  requestTypeContracts,
  changeKit,
}) => {
  useEffect(() => {
    const { params } = match;
    if (params.id) {
      candidateFiles({ id: params.id });
    }
  }, []);
  const [showDialogYesOrNo, setShowDialogYesOrNo] = useState(0);
  const [showDialogNewFileYesOrNo, setshowDialogNewFileYesOrNo] =
    useState(false);
  const token = localStorage.getItem("Authorization");
  const [mensagemReprovacao, setMensagemReprovacao] = useState("");
  const [contractSelected, setcontractSelected] = useState();

  const hiddenFileInput = React.createRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const uploadNewContract = (e, idDocument) => {
    incluseNewDoc({ file: e, idDocument: idDocument });
    e = null;
  };

  const changeContract = (e, idCandidateEmEtapa) => {
    changeContractRequest({ file: e, idCandidateEmEtapa: idCandidateEmEtapa });
    e = null;
  };

  const canShowDialog = (idDoc) => {
    return showDialogYesOrNo == idDoc;
  };

  const setColorStatus = (status) => {
    switch (status) {
      case 2:
        return { fontWeight: "bold", color: "#d01616" };
      case 3:
        return { fontWeight: "bold", color: "#32a34c" };
      default:
        return {};
    }
  };
  const [formObservacaoValues, setFormObservacaoValues] = useState({
    observacao: "",
  });
  const [formTipoContratoValues, setFormTipoContratoValues] = useState({
    tipoContrato: "",
  });
  useEffect(() => {
    requestTypeContracts();
  }, []);

  const [showDialog, setShowDialog] = useState(false);
  const [showTipoContratoDialog, setShowTipoContratoDialog] = useState(false);
  const [fileAditional, setfileAditional] = useState();

  const [exibirReprovados, setExibirReprovados] = useState(false);

  const reUploadContrato = (e, idCandidatoEmEtapa, messageParaCandidato) => {
    requestReUploadContract({
      file: e,
      idCandidatoEmEtapa: idCandidatoEmEtapa,
      messageParaCandidato: messageParaCandidato,
    });
    e = null;
  };

  const confirmaAnaliseDocumentos = (
    idcandidateEtapa,
    dispensar,
    observacao
  ) => {
    confirmAnalisys({
      id: idcandidateEtapa,
      dispensar,
      observacao,
    });
  };

  const setStatusFile = (fileData, message) => {
    if (fileData.status == "3") {
      setStatusFileRequest({
        idDocumento: fileData.fileId,
        idCandidatoEmEtapa: fileData.IdCandidatoNaEtapa,
        status: 3,
        message: message,
      });
    } else {
      if (contractSelected == null || contractSelected == undefined) {
        setcontractSelected({
          idDocumento: fileData.fileId,
          idCandidatoEmEtapa: fileData.IdCandidatoNaEtapa,
          status: fileData.status,
          message: message,
        });
      } else {
        setcontractSelected({ ...contractSelected, message: message });
      }

      if (fileData.status == "2" && (message == undefined || message == "")) {
        setShowDialogYesOrNo(fileData.fileId);
      } else if (
        fileData.status == "2" &&
        message != undefined &&
        message != ""
      ) {
        setMensagemReprovacao(message);
        setShowDialogYesOrNo();
        setshowDialogNewFileYesOrNo(true);
      } else {
        setStatusFileRequest({
          idDocumento: contractSelected.fileId,
          idCandidatoEmEtapa: contractSelected.IdCandidatoNaEtapa,
          status: contractSelected.status,
          message: message,
        });
      }
    }
  };

  const confirmNewDocCandidate = (fileData, message) => {
    handleClick();
  };
  const reprovSemNovoArquivar = (fileData) => {
    setshowDialogNewFileYesOrNo();
    setStatusFileRequest({
      idDocumento: fileData.idDocumento,
      idCandidatoEmEtapa: fileData.idCandidatoEmEtapa,
      status: fileData.status,
      message: fileData.message,
    });
  };

  const statusAprovado = (status) => {
    return status === "Aprovado";
  };
  const finalizarEstapa = (status) => {
    if (statusAprovado(status)) {
      setShowDialog(true);
    } else {
      confirmaAnaliseDocumentos(filesCandidateSelected.idCandidatoEtapa, true);
    }
  };

  const renderFilesCandidatesTable = (
    candidateDocs,
    setStatusFile,
    token,
    canShowDialog,
    setShowDialogYesOrNo,
    setshowDialogNewFileYesOrNo
  ) => {
    return (
      <div>
        <Row>
          <Col md={4}>
            <label style={{ fontWeight: "bold", color: "#005394" }}>
              Nome:&nbsp;
            </label>
            <Label bold>{candidateDocs.nome}</Label>
          </Col>
          <Col md={2}>
            <label style={{ fontWeight: "bold", color: "#005394" }}>
              CPF:&nbsp;
            </label>
            <Label bold>{candidateDocs.cpf}</Label>
          </Col>
          <Col md={3}>
            <label style={{ fontWeight: "bold", color: "#005394" }}>
              Status Etapa:&nbsp;
            </label>
            <Label bold>{candidateDocs.statusEtapa}</Label>
          </Col>

          <Col md={3} style={{ marginBottom: "-5px" }}>
            <label style={{ fontWeight: "bold", color: "#005394" }}>
              Kit:&nbsp;
            </label>
            <Label bold>{candidateDocs.kit}</Label>
          </Col>
          <Col md={2} style={{ marginBottom: "-17px" }}></Col>
        </Row>
        {candidateDocs.divergencia &&
          filesCandidateSelected.statusEtapa === "Divergência" && (
            <Row>
              <Col md={12}>
                <label style={{ fontWeight: "bold", color: "red" }}>
                  Divergência:&nbsp;
                </label>
                <Label bold>{candidateDocs.divergencia}</Label>
              </Col>
            </Row>
          )}
        <Table>
          <TableBody>
            <TableRow noBorder>
              <TableHead style={{ width: "5px" }}>
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.columns.idDocument" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.columns.typeDocument" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.columns.document" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>Instruções</LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>Sinalização do candidato</LabelHeader>
              </TableHead>
            </TableRow>
            {candidateDocs.filesList &&
              renderTableFilesItems(
                candidateDocs,
                setStatusFile,
                token,
                candidateDocs.podeEditar,
                canShowDialog,
                setShowDialogYesOrNo,
                setshowDialogNewFileYesOrNo
              )}
          </TableBody>
        </Table>
      </div>
    );
  };
  const renderTableFilesItems = (
    candidates,
    setStatusFile,
    token,
    podeEditar,
    canShowDialog,
    setShowDialogYesOrNo,
    setshowDialogNewFileYesOrNo
  ) =>
    candidates.filesList.map((file) => (
      <TableRow style={file.status == 5 ? { display: "none" } : {}}>
        <TableColumn ta="left">
          <Label>{file.Id}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{file.type}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{file.nome}</Label>
        </TableColumn>
        <TableColumn ta="left ">
          <Label>{file.instrucao}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{file.divergencia}</Label>
        </TableColumn>
        <TableColumn ta="right" action>
          <Actions
            flexPosition="flex-start"
            onClick={() =>
              window.open(
                `${file.url_contrato}?Authorization=${token}`,
                "_blank"
              )
            }
            style={{ cursor: "progress" }}
          >
            <ActionItem>
              {view()}
              <LabelAction>
                <FormattedMessage id="contracts.View_default_contract" />
              </LabelAction>
            </ActionItem>
          </Actions>
        </TableColumn>
        <TableColumn ta="right" action>
          <Actions
            flexPosition="flex-start"
            onClick={() =>
              window.open(
                `${file.url_contratoAssinado}?Authorization=${token}`,
                "_blank"
              )
            }
            style={{ cursor: "progress" }}
          >
            <ActionItem
              style={
                file.status == 2 ||
                file.status == 0 ||
                file.url_contratoAssinado == ""
                  ? { display: "none" }
                  : {}
              }
            >
              {view()}
              <LabelAction>
                <FormattedMessage id="contracts.View_assigned_contract" />
              </LabelAction>
            </ActionItem>
          </Actions>
        </TableColumn>
        <TableColumn
          style={file.status == 5 ? { color: "#adb5bd" } : { display: "none" }}
          ta="center"
          action
        >
          <Label bold>Reprovado</Label>
        </TableColumn>
        <YesOrNoWithTextDialog
          cancelAction={() => {
            setShowDialogYesOrNo();
            setcontractSelected();
          }}
          show={canShowDialog(candidates.idCandidatoEtapa)}
          question={"Informe as instruções para o candidato."}
          confirmAction={setStatusFile}
          ShowNoUntilCancel={false}
          showMessage={true}
          idConfirm={{
            fileId: file.Id,
            status: "2",
            IdCandidatoNaEtapa: candidates.idCandidatoEtapa,
            mensagem: mensagemReprovacao,
          }}
        />
        <YesOrNoWithTextDialog
          cancelAction={() => {
            reprovSemNovoArquivar(contractSelected);
          }}
          show={showDialogNewFileYesOrNo}
          showMessage={false}
          ShowNoUntilCancel={true}
          question={"Deseja alterar o contrato do candidato?"}
          confirmAction={confirmNewDocCandidate}
          idConfirm={{
            fileId: file.Id,
            status: "2",
            IdCandidatoNaEtapa: candidates.idCandidatoEtapa,
            mensagem: mensagemReprovacao,
          }}
        />
      </TableRow>
    ));

  if (isLoading) return <Load isLoading={isLoading} />;
  return (
    <React.Fragment>
      <BreadCrumb
        location={location}
        title={"Status contratos"}
      />
      <Body>
        <ButtonDefault
          onClick={() => redirectToContracts()}
          width="230px"
          mr="10px"
          name={"Voltar"}
        />
        {renderFilesCandidatesTable(
          filesCandidateSelected,
          setStatusFile,
          token,
          canShowDialog,
          setShowDialogYesOrNo,
          setshowDialogNewFileYesOrNo
        )}
        {filesCandidateSelected.statusEtapa !==
          "Aguardando Aceite Alteração do Contrato" &&
          filesCandidateSelected.statusEtapa !==
            "Aguardando Aceite Cancelamento" && (
            <React.Fragment>
              {filesCandidateSelected.statusEtapa !== "Dispensado" && (
                <ButtonDefault
                  name={
                    statusAprovado(filesCandidateSelected.statusEtapa)
                      ? "Aceite alteração contrato"
                      : "Cancelar Etapa"
                  }
                  width={
                    statusAprovado(filesCandidateSelected.statusEtapa)
                      ? "260px"
                      : "230px"
                  }
                  onClick={() =>
                    finalizarEstapa(filesCandidateSelected.statusEtapa)
                  }
                  style={{ backgroundColor: "#eb4c4c" }}
                ></ButtonDefault>
              )}
              {filesCandidateSelected.statusEtapa !== "Dispensado" &&
                filesCandidateSelected.statusEtapa !== "Aprovado" && (
                  <ButtonDefault
                    name={"Alterar Kit"}
                    mr="18px"
                    width="230px"
                    ml="18px"
                    onClick={() => setShowTipoContratoDialog(true)}
                  ></ButtonDefault>
                )}

              {filesCandidateSelected.podeReAnalisarEtapa && (
                <ButtonDefault
                  onClick={() =>
                    confirmaAnaliseDocumentos(
                      filesCandidateSelected.idCandidatoEtapa,
                      false
                    )
                  }
                  width="280px"
                  mr="18px"
                  name={
                    filesCandidateSelected.statusEtapa === "Divergência"
                      ? "Reabilitar assinatura"
                      : "Alterar etapa para Analise"
                  }
                  style={
                    !filesCandidateSelected.podeConfirmar &&
                    !filesCandidateSelected.podeReAnalisarEtapa
                      ? {}
                      : { backgroundColor: "#1ebb42db" }
                  }
                  disabled={
                    !filesCandidateSelected.podeConfirmar &&
                    !filesCandidateSelected.podeReAnalisarEtapa
                  }
                />
              )}
              <DialogInsertObservacao
                setFormValues={setFormObservacaoValues}
                formValues={formObservacaoValues}
                show={showDialog}
                setShowDialog={setShowDialog}
                addItem={() => {
                  confirmaAnaliseDocumentos(
                    filesCandidateSelected.idCandidatoEtapa,
                    true,
                    formObservacaoValues.observacao
                  );
                }}
              />
              <DialogInsertTipoContrato
                tipoContratoList={tipoContratoList}
                setFormValues={setFormTipoContratoValues}
                formValues={formTipoContratoValues}
                show={showTipoContratoDialog}
                setShowDialog={setShowTipoContratoDialog}
                addItem={() => {
                  setShowTipoContratoDialog(false);
                  changeKit({
                    id: filesCandidateSelected.idCandidatoEtapa,
                    cpf: filesCandidateSelected.cpf,
                    tipoContrato: formTipoContratoValues.tipoContrato,
                  });
                }}
              />
            </React.Fragment>
          )}
      </Body>
    </React.Fragment>
  );
};
const DialogInsertTipoContrato = ({
  show,
  setFormValues,
  formValues,
  addItem,
  setShowDialog,
  showDialog,
  tipoContratoList,
}) => {
  useEffect(() => {}, [formValues]);

  const closeModal = () => {
    setShowDialog(!show);
  };

  const handleClose = () => setShowDialog(false);
  return (
    <Modal size="lg" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Title
          size="1.500em"
          color="title"
          title={<FormattedMessage id="contracts.sendConfirmMsgTitleKit" />}
        />
      </Modal.Header>
      <Modal.Body>
        <Row style={{ marginTop: "10px" }}>
          <Col
            lg={12}
            style={{ marginTop: "10px", display: "flex", flexFlow: "column" }}
          >
            <SelectFieldInput
              onChange={(e) =>
                setFormValues({ ...formValues, tipoContrato: e.target.value })
              }
              value={formValues.tipoContrato}
              items={tipoContratoList}
              width="100%"
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Col lg={{ size: 2, offset: 6 }}>
          <ButtonSecondary
            onClick={() => closeModal()}
            name={<FormattedMessage id="sharedItems.cancel" />}
          />
        </Col>
        <Col lg={{ size: 2 }}>
          <ButtonDefault
            disabled={!formValues.tipoContrato}
            onClick={() => addItem()}
            name={<FormattedMessage id="contracts.confirmSendKitMessage" />}
          />
        </Col>
      </Modal.Footer>
    </Modal>
  );
};
const DialogInsertObservacao = ({
  show,
  setFormValues,
  formValues,
  addItem,
  setShowDialog,
  showDialog,
}) => {
  useEffect(() => {}, [formValues]);

  const closeModal = () => {
    setShowDialog(!show);
  };

  const handleClose = () => setShowDialog(false);
  return (
    <Modal size="lg" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Title
          size="1.500em"
          color="title"
          title={<FormattedMessage id="contracts.sendConfirmMsgTitle" />}
        />
      </Modal.Header>
      <Modal.Body>
        <Row style={{ marginTop: "10px" }}>
          <Col
            lg={12}
            style={{ marginTop: "10px", display: "flex", flexFlow: "column" }}
          >
            <TextAreaField
              onChange={(e) =>
                setFormValues({ ...formValues, observacao: e.target.value })
              }
              value={formValues.observacao}
              label={
                <FormattedMessage id="contracts.sendConfirmMsgDescription" />
              }
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Col lg={{ size: 2, offset: 6 }}>
          <ButtonSecondary
            onClick={() => closeModal()}
            name={<FormattedMessage id="sharedItems.cancel" />}
          />
        </Col>
        <Col lg={{ size: 2 }}>
          <ButtonDefault
            disabled={!formValues.observacao}
            onClick={() => addItem()}
            name={<FormattedMessage id="contracts.confirmSendMessage" />}
          />
        </Col>
      </Modal.Footer>
    </Modal>
  );
};
const mapDispatchToProps = (dispatch) => ({
  candidateFiles: (id) =>
    dispatch(contractsAction.candidateContractRequest(id)),
  setStatusFileRequest: (payload) =>
    dispatch(contractsAction.candidateSetStatusContractFileRequest(payload)),
  confirmAnalisys: (payload) =>
    dispatch(contractsAction.candidateContractSetStatusStageRequest(payload)),
  incluseNewDoc: (payload) =>
    dispatch(contractsAction.candidateIncludeNewContractRequest(payload)),
  redirectToContracts: (id) => dispatch(push(`${urls.CONTRACTS_LIST}`)),
  requestReUploadContract: (payload) =>
    dispatch(contractsAction.candidateContractResendRequest(payload)),
  changeContractRequest: (payload) =>
    dispatch(contractsAction.candidateChangeContractRequest(payload)),
  requestTypeContracts: (payload) =>
    dispatch(contractsAction.typeContractsRequest()),
  changeKit: (payload) =>
    dispatch(contractsAction.candidateChangeKitContractRequest(payload)),
});
const mapStateToProps = (state) => ({
  tipoContratoList: state.contracts.tipoContratoList,
  isLoading: state.contracts.isLoading,
  filesCandidateSelected: state.documents.candidatesFiles,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailContractCandidate);

DetailContractCandidate.propTypes = {
  filesCandidateSelected: PropTypes.func,
};

DetailContractCandidate.defaultProps = {
  candidates: () => {},
  filesCandidateSelected: () => {},
};
